import React, { useState, useRef, useEffect } from 'react';
import './ChatAI.css';

function ChatAI() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: 'bot', text: 'Miao! 🐱 Sono Tanjie, l\'assistente virtuale di Giovanni. Chiedi pure!' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [messages]);

  // Focus sull'input quando si apre la chat
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  // Chiusura con tasto Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim() || loading) return;

    const userMsg = input;
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setLoading(true);

    try {
      const response = await fetch('/api_chat.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: userMsg }),
      });

      // Se il file non esiste (404) o il server esplode (500)
      if (!response.ok) {
        throw new Error(`Errore Server: ${response.status}`);
      }

      const data = await response.json();

      // Controllo se c'è un errore dal server
      if (data && data.status === 'error') {
        // Mostra il messaggio di errore dal server
        setMessages(prev => [...prev, { role: 'bot', text: data.message }]);
      }
      // Controllo se Gemini ha risposto correttamente
      else if (data && data.candidates && data.candidates[0]?.content?.parts?.[0]?.text) {
        const botReply = data.candidates[0].content.parts[0].text;
        setMessages(prev => [...prev, { role: 'bot', text: botReply }]);
      }
      else {
        // Risposta in formato non riconosciuto
        setMessages(prev => [...prev, {
          role: 'bot',
          text: "Mi dispiace, non sono riuscito a elaborare la risposta. Riprova o contattami tramite il form!"
        }]);
      }

    } catch (error) {
      console.error("Errore Chat:", error);
      setMessages(prev => [...prev, {
        role: 'bot',
        text: "Ops! Si è verificato un errore di connessione. Riprova tra poco!"
      }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`chat-container ${isOpen ? 'open' : ''}`}>
      <button
        className="chat-launcher"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Chiudi chat con Tanjie' : 'Apri chat con Tanjie'}
        aria-expanded={isOpen}
        aria-controls="chat-dialog"
      >
        <span aria-hidden="true">{isOpen ? '✕' : '💬'}</span>
      </button>

      {isOpen && (
        <div
          id="chat-dialog"
          className="chat-box"
          role="dialog"
          aria-label="Chat con Tanjie, assistente virtuale"
          aria-modal="true"
        >
          <div className="chat-header">
            <div className="chat-header-content">
              <img
                src="/tanjie-avatar.png"
                alt="Avatar di Tanjie, un gatto virtuale"
                className="chat-avatar"
              />
              <h4>Tanjie</h4>
            </div>
            <div className="status-dot" aria-label="Online" role="status"></div>
          </div>
          <div
            className="chat-body"
            role="log"
            aria-live="polite"
            aria-atomic="false"
            aria-label="Conversazione"
          >
            {messages.map((m, i) => (
              <div
                key={i}
                className={`msg-row ${m.role}`}
                role={m.role === 'bot' ? 'article' : 'article'}
                aria-label={m.role === 'bot' ? 'Messaggio di Tanjie' : 'Tuo messaggio'}
              >
                <div className="msg-bubble">{m.text}</div>
              </div>
            ))}
            {loading && (
              <div className="msg-row bot" role="status" aria-label="Tanjie sta scrivendo">
                <div className="msg-bubble typing">...</div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
          <form onSubmit={handleSend} className="chat-footer" aria-label="Invia messaggio">
            <label htmlFor="chat-input" className="sr-only">Scrivi un messaggio a Tanjie</label>
            <input
              id="chat-input"
              ref={inputRef}
              type="text"
              placeholder="Scrivi un messaggio..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              aria-label="Campo messaggio"
              disabled={loading}
            />
            <button
              type="submit"
              aria-label="Invia messaggio"
              disabled={loading || !input.trim()}
            >
              <span aria-hidden="true">➤</span>
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default ChatAI;